import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class HeaderEffects {
  constructor(private actions$: Actions) {
    // Effects
  }
}
